import { Route, Routes, BrowserRouter, } from "react-router-dom";
import AuthorizedLayout from './layouts/AuthorizedLayout';
import VoucherRoute from './areas/voucherSearch/routes/VoucherRoute';
import { useTheme } from "@mui/material";
import GuestLayout from "./layouts/GuestLayout";
import LoginRoute from "./common/routes/LoginRoute";
import HomeRoute from "./areas/home/routes/HomeRoute";
import DashboardPendingWorkRoute from "./areas/dashboard/routes/DashboardPendingWorkRoute";
import ReportsResultsRoute from "./areas/reports/routes/ReportsResultsRoute";
import ReportsOpenEntriesRoute from "./areas/reports/routes/ReportsOpenEntriesRoute";
import ReportsCashRegisterRoute from "./areas/reports/routes/ReportsCashRegisterRoute";
import DocumentsMy from "./areas/approvers/routes/DocumentsMy";
import DocumentsMyPrevious from "./areas/approvers/routes/DocumentsMyPrevious";
import DocumentsAll from "./areas/approvers/routes/DocumentsAll";
import FlowApproval from "./areas/approvers/routes/FlowApproval";
import Approvers from "./areas/approvers/routes/Approvers";
import NewPasswordRoute from "./common/routes/NewPasswordRoute";
import Actors from "./areas/actors/routes/Actors";
import Organization from "./areas/settings/routes/Organization";
import People from "./areas/settings/routes/People";
import CashRegisterSettings from "./areas/settings/routes/CashRegisterSettings";
import ProductGroup from "./areas/settings/routes/ProductGroup";
import VoucherRegistration from "./areas/voucherRegistration/routes/VoucherRegistration";
import UserProfileRoute from "./areas/accounts/routes/UserProfileRoute";
import SourceDocumentWeblink from "./areas/permalink/SourceDocumentWeblink";

const AppRoutes = (): JSX.Element => {

    const theme = useTheme();


    //const [resultUser, setResultUser] = useState<Result<IUserContextModel>>();
    //const [resultUserErrors, setResultUserErrors] = useState<string[]>([]);
    //const { t, i18n } = useTranslation();

    //useLayoutEffect(() => {
    //    let isMounted = true; //Avoid memory leaks. Async function running after dismount.
    //    const service = new UserContextService();
    //    const getData = async () => {
    //        const result = await service.getUserContext();
    //        if (!result.hasErrors) {
    //            if (isMounted) {
    //                setResultUser(result);
    //                i18n.changeLanguage(result.value.language.replace(/-/g, ""));
    //                setResultUserErrors([]);
    //            }
    //        } else {
    //            setResultUserErrors(result.errors);
    //        }
    //    };
    //    getData();

    //    return () => { isMounted = false };

    //}, []);


    //function isLogin() {
    //    if (resultUser != null && !resultUser.hasErrors && resultUser.code !== 403) {
    //        return <Route path="/" element={<AuthorizedLayout />}>
    //            <Route path="/Dashboard" element={<DashboardPendingWorkRoute />} />
    //            <Route path="/Firm/:organizationId">
    //                <Route index element={<HomeRoute />} />
    //                <Route path="/Firm/:organizationId/VoucherSearch" element={<VoucherRoute />} />
    //                <Route path="/Firm/:organizationId/Reports/Result" element={<ReportsResultsRoute />} />
    //                <Route path="/Firm/:organizationId/Reports/CashRegister" element={<ReportsCashRegisterRoute />} />
    //                <Route path="/Firm/:organizationId/Reports/OpenEntries/:userType" element={<ReportsOpenEntriesRoute />} />
    //                <Route path="/Firm/:organizationId/Approver/MyDocuments" element={<DocumentsMy />} />
    //                <Route path="/Firm/:organizationId/Approver/MyPreviousDocuments" element={<DocumentsMyPrevious />} />
    //                <Route path="/Firm/:organizationId/Approver/AllDocuments" element={<DocumentsAll />} />
    //                <Route path="/Firm/:organizationId/Approver/ApprovalFlow" element={<FlowApproval />} />
    //                <Route path="/Firm/:organizationId/Approver/Approvers" element={<Approvers />} />
    //                <Route path="*" element={
    //                    <main style={{ padding: theme.spacing(1) }}>
    //                        <p>Error 404: Page Not Found.</p>
    //                    </main>
    //                } />
    //            </Route>
    //            <Route path="*" element={
    //                <main style={{ padding: theme.spacing(1) }}>
    //                    <p>Error 404: Page Not Found.</p>
    //                </main>
    //            } />
    //        </Route>
    //    } else {
    //        return <Route path="/" element={<GuestLayout />}>
    //            <Route index element={<LoginRoute />} />
    //            <Route path="*" element={
    //                <main style={{ padding: theme.spacing(1) }}>
    //                    <p>Error 404: Page Not Found.</p>
    //                </main>
    //            } />
    //        </Route>
    //    }
    //}
    //return <BrowserRouter basename="/NewUI">
    //    <Routes>
    //        {isLogin()}
    //    </Routes>
    //</BrowserRouter>

    return <BrowserRouter basename="/">
        <Routes>
            <Route path="/" element={<GuestLayout />}>
                <Route index element={<LoginRoute />} />
                <Route path="/ResetPassword/:token" element={<NewPasswordRoute />} />
                <Route path="*" element={
                    <main style={{ padding: theme.spacing(1) }}>
                        <p>Error 404: Page Not Found.</p>
                    </main>
                } />
                
            </Route>
            <Route path="/Firm/:organizationId" element={<AuthorizedLayout />}>
                <Route index element={<HomeRoute />} />
                <Route path="/Firm/:organizationId/VoucherSearch" element={<VoucherRoute />} />
                <Route path="/Firm/:organizationId/Dashboard" element={<DashboardPendingWorkRoute />} />
                <Route path="/Firm/:organizationId/Reports/Result" element={<ReportsResultsRoute />} />
                <Route path="/Firm/:organizationId/Reports/CashRegister" element={<ReportsCashRegisterRoute />} />
                <Route path="/Firm/:organizationId/Reports/OpenEntries/:userType" element={<ReportsOpenEntriesRoute />} />
                <Route path="/Firm/:organizationId/Approver/MyDocuments" element={<DocumentsMy />} />
                <Route path="/Firm/:organizationId/Approver/MyPreviousDocuments" element={<DocumentsMyPrevious />} />
                <Route path="/Firm/:organizationId/Approver/AllDocuments" element={<DocumentsAll />} />
                <Route path="/Firm/:organizationId/Approver/ApprovalFlow" element={<FlowApproval />} />
                <Route path="/Firm/:organizationId/Approver/Approvers" element={<Approvers />} />
                <Route path="/Firm/:organizationId/Actors/Customers" element={<Actors type="Customer"/>} />
                <Route path="/Firm/:organizationId/Actors/Suppliers" element={<Actors type="Supplier" />} />
                <Route path="/Firm/:organizationId/Settings/Organization" element={<Organization />} />
                <Route path="/Firm/:organizationId/Settings/People" element={<People />} />
                <Route path="/Firm/:organizationId/Settings/CashRegisterSettings" element={<CashRegisterSettings />} />
                <Route path="/Firm/:organizationId/Settings/ProductGroup" element={<ProductGroup />} />
                <Route path="/Firm/:organizationId/VoucherRegistration/Incoming" element={<VoucherRegistration type="IncomingInvoice" />} />
                <Route path="/Firm/:organizationId/VoucherRegistration/Outgoing" element={<VoucherRegistration type="OutgoingInvoice" />} />
                <Route path="/Firm/:organizationId/VoucherRegistration/Banking" element={<VoucherRegistration type="Banking" />} />
                <Route path="/Firm/:organizationId/VoucherRegistration/JournalEntries" element={<VoucherRegistration type="JournalEntries" />} />
                <Route path="/Firm/:organizationId/VoucherRegistration/Miscellaneous" element={<VoucherRegistration type="Miscellaneous" />} />
                <Route path="/Firm/:organizationId/VoucherRegistration/Addition" element={<VoucherRegistration type="Addition" />} />
                <Route path="/Firm/:organizationId/VoucherRegistration/Cash" element={<VoucherRegistration type="Cash" />} />
                <Route path="/Firm/:organizationId/VoucherRegistration/Statement" element={<VoucherRegistration type="Statement" />} />
                <Route path="/Firm/:organizationId/Account/Profile" element={<UserProfileRoute />} /> 
                <Route path="*" element={
                    <main style={{ padding: theme.spacing(1) }}>
                        <p>Error 404: Page Not Found.</p>
                    </main>
                } />
            </Route>
            <Route path="/permalink/V1/Organization/:organizationId" element={<AuthorizedLayout />}>
                <Route path="/permalink/V1/Organization/:organizationId/SourceDocument/:documentId" element={<SourceDocumentWeblink />} />
                <Route path="*" element={
                    <main style={{ padding: theme.spacing(1) }}>
                        <p>Error 404: Page Not Found.</p>
                    </main>
                } />
            </Route>
        </Routes>
    </BrowserRouter>
}
export default AppRoutes;